module.exports = __webpack_public_path__ + "static/media/arrow-back.cdf80356.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/arrow-back.svg
// module id = 1987
// module chunks = 0